import type { Signal } from '@angular/core'
import { Injectable, inject } from '@angular/core'
import type { ChecklistItem } from '@awork/features/task/models/checklist-item'
import { ChecklistItemStore } from '@awork/features/task/state/checklist-item.store'
import { EntitySignalQuery } from '@awork/core/state/signal-store/entitySignalQuery'
import { Order } from '@awork/core/state/signal-store/types'

@Injectable({ providedIn: 'root' })
export class ChecklistItemQuery extends EntitySignalQuery<ChecklistItem> {
  protected store: ChecklistItemStore

  constructor() {
    const store = inject(ChecklistItemStore)

    super(store)

    this.store = store
  }

  /**
   * Gets the checklist items for a specific task
   * @param {string} taskId - The ID of the task
   * @returns {Signal<ChecklistItem[]>} - A signal that emits checklist items sorted by order
   */
  queryByTask(taskId: string): Signal<ChecklistItem[]> {
    return this.queryAll({
      filterBy: checklistItem => checklistItem.taskId === taskId,
      sortBy: 'order',
      sortByOrder: Order.ASC
    })
  }

  /**
   * Gets the checklistItems of a task
   * @param {string} taskId
   * @returns {ChecklistItem[]}
   */
  getByTask(taskId: string): ChecklistItem[] {
    const checklistItems = this.getAll({
      filterBy: checklistItem => checklistItem.taskId === taskId,
      sortBy: 'order',
      sortByOrder: Order.ASC
    })

    return this.mapEntities(checklistItems)
  }
}
